import React from "react";
import { Button, Form } from "react-bootstrap";
import Select from "react-select";
import "./Quality_Plan_Form.css";

function Quality_Plan_Form({ onProceed }) {
  const verificationOptions = [
    { value: "crm", label: "Use Of CRM/Srms" },
    { value: "internal", label: "Internal Verification" },
  ];

  const parameterFields = ["Moist", "ASH%", "GCV"];

  return (
    <section className="Legal_Entity_Form">
      <div className="white_container customer_section">

        {/* ===== TOP ROW ===== */}
        <div className="row">
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Type Of Verification</Form.Label>
              <Select
                options={verificationOptions}
                placeholder="Enter Type Of Verification"
                classNamePrefix="react_select"
              />
            </Form.Group>
          </div>

          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Frequency</Form.Label>
              <Form.Control placeholder="Enter Frequency" />
            </Form.Group>
          </div>
        </div>

        {/* ===== ACCEPTANCE PARAMETER CRITERIA ===== */}
        <div className="row mt-3">
          <div className="col-md-12">
            <Form.Label>Acceptance Parameter Criteria</Form.Label>
          </div>

          {parameterFields.map((label, index) => (
            <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-3" key={index}>
              <div className="observation_box">
                <div className="obs_label">{label}</div>
                <div className="form_field_holder">
                  <Form.Control />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* ===== FOOTER BUTTONS ===== */}
        <div className="permission_btn_holder mt-4">
          <Button className="permission_btn No_btn">Cancel</Button>
          <Button className="permission_btn Yes_btn" onClick={onProceed}>
            Save
          </Button>
        </div>

      </div>
    </section>
  );
}

export default Quality_Plan_Form;
